import React, { useEffect, useState, useContext, useMemo, useCallback } from "react";
import { flightAvailability } from "../../Services/API";
import { useLocation } from "react-router-dom";
import { flightPricing } from "../../Services/API";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../Routes/AuthProvider";
import Header from "../../Components/Header";
import ModifySearch from "./ModifySearch";

import ResultHtml from "./ResultHtml";
import DomRoundTrip from "./DomRoundTrip";
import IntRoundTrip from "./IntRoundTrip";
import FilterSidebar from "./FilterSidebar";
import FilterSidebarDom from "./FilterSidebarDom";
import { useNavigate } from "react-router-dom";
import { SaveApprovalLowFareFlights } from "../../Services/API"


const Result = () => {
  const { corporateId, userName } = useContext(AuthContext);
  const [flights, setFlights] = useState([]);
  const [userSelectedFlight, setUserSelectedFlight] = useState([]);
  const [onwardList, setOnwardList] = useState([]);
  const [returnList, setReturnList] = useState([]);
  const [flightRequst, setFlightRequst] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pricingLoading, setPricingLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [allCompleted, setAllCompleted] = useState(false);
  const [onwardFlights, setOnwardFlights] = useState([]); // one-way
  const [returnFlights, setReturnFlights] = useState([]); // round trip
  const [showPopup, setShowPopup] = useState(false);
  const [islowestFlight, setIslowestFlight] = useState(false);
  const [priceDiff, setPriceDiff] = useState(0);
  const [pendingBooking, setPendingBooking] = useState(null);
  const [recommendedFlight, setRecommendedFlight] = useState(null);
  const [flightType, setFlightType] = useState(null);

  const [flightRequest, setFlightRequest] = useState(null);
  const [selectedFareMap, setSelectedFareMap] = useState({});
  const [selectedOption, setSelectedOption] = useState("default");
  const [selectedFlightPrice, setSelectedFlightPrice] = useState(0);
  const [recommendedFlightPrice, setRecommendedFlightPrice] = useState(0);
  const [highestFlightPrice, setHighestFlightPrice] = useState(0);
  const [remark, setRemark] = useState("");
  const [otherRemark, setOtherRemark] = useState("");
  const [errors, setErrors] = useState({
    remark: "",
    otherRemark: ""
  });

  const searchData =
    location.state ||
    JSON.parse(sessionStorage.getItem("searchData")) ||
    Object.fromEntries(new URLSearchParams(location.search));

  const data = searchData.searchParams || searchData;
  const [guidNo, setGuidNo] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const flightlist =
    location.state ||
    JSON.parse(sessionStorage.getItem("searchData") || "{}");

  const {
    onwardDate = "",
    returnDate = "",
    departureQuery = "",
    arrivalQuery = ""
  } = flightlist;


  const isRoundTrip = !!returnDate;
  // const indianAirports = [
  //   "DEL", "BOM", "MAA", "BLR", "HYD", "CCU", "GOI", "PNQ", "AMD", "COK", "TRV",
  //   "IXC", "LKO", "GAU", "PAT", "RPR", "JAI", "IXB", "VNS", "SXR", "UDR", "BHO", "NAG"
  // ];

  const originCode = data.departureQuery?.split("(")[1]?.split(")")[0];
  const destCode = data.arrivalQuery?.split("(")[1]?.split(")")[0];

  const isDomestic = data.departureQuery.includes("India") && data.arrivalQuery.includes("India");

  const [filters, setFilters] = useState({
    onwardDate: data.onwardDate || "",
    returnDate: data.returnDate || ""
  });

  useEffect(() => {
    const corporate = localStorage.getItem("selectedCorporateCode");
    const userId = localStorage.getItem("selectedUserId");

    if (corporate) setSelectedCorporate(corporate);
    if (userId) setSelectedUser(userId);
  }, []);

  const handleFilterChange = (updatedFilter) => {
    setFilters((prev) => ({ ...prev, ...updatedFilter }));
  };


  const filteredFlights = flights.filter((f) => {

    const segment = f.segments?.[0];
    if (!segment) return false;

    const departDateTime = segment.departDateTime;
    const apiDate = departDateTime?.split("T")[0]; // FIXED (no timezone shift)

    //  DATE FILTER
    if (filters.onwardDate && apiDate !== filters.onwardDate) return false;

    // AIRLINES FILTER
    if (filters.airlines?.length > 0) {
      const airlineName =
        segment.airLineName ||
        segment.carrierName ||
        segment.airlineName ||
        "";

      if (!filters.airlines.includes(airlineName)) return false;
    }

    // STOP FILTER
    if (filters.stops?.length > 0) {
      const stopCount = String(f.stops ?? f.totalStops ?? 0);
      if (!filters.stops.includes(stopCount)) return false;
    }

    //  FARE TYPE FILTER
    if (filters.fareType?.length > 0) {
      const fareType = f.fares?.[0]?.isRefundable
        ? "Refundable"
        : "Non-Refundable";
      if (!filters.fareType.includes(fareType)) return false;
    }

    //  DEPARTURE TIME FILTER
    if (filters.departureTimes?.length > 0) {
      const hour = new Date(departDateTime).getHours();

      const category =
        hour >= 5 && hour <= 11
          ? "morning"
          : hour >= 12 && hour <= 17
            ? "afternoon"
            : hour >= 18 && hour <= 20
              ? "evening"
              : hour >= 21 && hour <= 23
                ? "night"
                : "lateNight";

      if (!filters.departureTimes.includes(category)) return false;
    }

    return true; // KEEP the flight
  });


  useEffect(() => {
    setGuidNo(uuidv4());
  }, []);

  const [selectedFare, setSelectedFare] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);


  // const segments = [
  //   {
  //     origin: data.departureQuery?.split("(")[1]?.split(")")[0] || "",
  //     destination: data.arrivalQuery?.split("(")[1]?.split(")")[0] || "",
  //     departDate: data.onwardDate ? formatDateForAPI(data.onwardDate) : "",
  //     preferredClass: data.selClass || "ECONOMY",
  //   }
  // ];

  // if (isRoundTrip) {
  //   segments.push({
  //     origin: data.arrivalQuery?.split("(")[1]?.split(")")[0] || "",
  //     destination: data.departureQuery?.split("(")[1]?.split(")")[0] || "",
  //     departDate: data.returnDate ? formatDateForAPI(data.returnDate) : "",
  //     preferredClass: data.selClass || "ECONOMY",
  //   });
  // }

  function formatDateForAPI(dateStr) {
    if (!dateStr) return "";

    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  }



  const getAirportCode = (value) => {
    if (!value) return "";
    const match = value.match(/\(([^)]+)\)/);
    return match ? match[1] : "";
  };

  const segments = [
    {
      origin: getAirportCode(data.departureQuery),
      destination: getAirportCode(data.arrivalQuery),
      departDate: formatDateForAPI(data.onwardDate),
      preferredClass: data.selClass || "ECONOMY",
    },
  ];

  if (isRoundTrip) {
    segments.push({
      origin: getAirportCode(data.arrivalQuery),
      destination: getAirportCode(data.departureQuery),
      departDate: formatDateForAPI(data.returnDate),
      preferredClass: data.selClass || "ECONOMY",
    });
  }

  const corporateCodeFromStorage = localStorage.getItem("selectedCorporateCode");
  const requestBody = {
    travelPurpose: Number(data.travelType || 0),
    trip: isDomestic ? 1 : 2,
    tripType: isRoundTrip ? 2 : 1,

    origin: segments[0].origin,
    destination: segments[0].destination,

    adult: Number(data.adult || 1),
    child: Number(data.child || 0),
    infant: Number(data.infant || 0),

    departDate: segments[0].departDate,
    returnDate: isRoundTrip ? segments[1].departDate : "",

    clientCode: "BerryJourneys",
    rtf: true,
    nonStop: !!data.nonStop,
    currency: "INR",
    planType: "NRML",
    preferredClass: data.selClass || "ECONOMY",
    preferredCarrier: data.airlinePreference || "",
    key: guidNo,
    sessionID: "",
    loggedInUserId: userName,
    corporatetraveller: selectedUser,

    segments: segments,

    preferredDepartureTime: Number(data.timePreference || 0),
    //preferredDepartureTime: 0,
    preferredArrivalTime: 0,
    fareType: data.fareType || "",
    corporateCode: (selectedCorporate) ? selectedCorporate : corporateId,
    source: "",
    originCountry: "IN",
    destinationCountry: "IN",
    isEmulated: !!corporateCodeFromStorage
  };

  //  Helper: Format time for display
  const formatTime = (dt) => {
    if (!dt) return "";
    try {
      const d = new Date(dt);
      return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } catch {
      return dt;
    }
  };

  const hasFetched = React.useRef(false);

  useEffect(() => {
    if (!guidNo) return;
    if (hasFetched.current) return;
    hasFetched.current = true;

    setLoading(true);
    setError(null);
    setAllCompleted(false);
    setFlights([]);
    setOnwardFlights([]);
    setReturnFlights([]);
    setFlightRequest(requestBody);

    flightAvailability(requestBody, (data) => {
      if (data.allCompleted) {
        setLoading(false);
        setAllCompleted(true);
        return;
      }

      if (data.status === "done") {
        setFlights((prev) => [...prev, ...(data.onward || [])]);
        setOnwardFlights((prev) => [...prev, ...(data.onward || [])]);
        setReturnFlights((prev) => [...prev, ...(data.return || [])]);

        //console.log("flightAvailability onward", data);
        //console.log("flightAvailability return", data.return);
      }
    });
  }, [guidNo]);

  const getFilteredFlights = (list, filterSet) => {
    return list.filter((f) => {

      const segment = f.segments?.[0];
      if (!segment) return false;

      // AIRLINE
      if (filterSet.airlines?.length) {

        const airline =
          segment.airLineName ||
          segment.carrierName ||
          segment.airlineName ||
          "";

        if (!filterSet.airlines.includes(airline))
          return false;
      }

      // STOPS
      const stops = String(f.stops ?? f.totalStops ?? 0);

      if (filterSet.stops?.length && !filterSet.stops.includes(stops))
        return false;

      // FARE TYPE
      if (filterSet.fareType?.length) {

        const fareType =
          f.fares?.[0]?.isRefundable
            ? "Refundable"
            : "Non-Refundable";

        if (!filterSet.fareType.includes(fareType))
          return false;
      }

      // DEPARTURE TIME
      if (filterSet.departureTimes?.length) {

        const hour = new Date(segment.departDateTime).getHours();

        const category =
          hour >= 5 && hour <= 11
            ? "morning"
            : hour >= 12 && hour <= 17
              ? "afternoon"
              : hour >= 18 && hour <= 20
                ? "evening"
                : hour >= 21 && hour <= 23
                  ? "night"
                  : "lateNight";

        if (!filterSet.departureTimes.includes(category))
          return false;
      }

      return true;
    });
  };

  // ONWARD FILTER STATE
  const [onwardFilters, setOnwardFilters] = useState({
    airlines: [],
    stops: [],
    fareType: [],
    departureTimes: []
  });

  // RETURN FILTER STATE
  const [returnFilters, setReturnFilters] = useState({
    airlines: [],
    stops: [],
    fareType: [],
    departureTimes: []
  });

  // ONWARD FILTER HANDLER
  const handleOnwardFilterChange = (updatedFilters) => {
    setOnwardFilters((prev) => ({
      ...prev,
      ...updatedFilters
    }));
  };

  // RETURN FILTER HANDLER
  const handleReturnFilterChange = (updatedFilters) => {
    setReturnFilters((prev) => ({
      ...prev,
      ...updatedFilters
    }));
  };

  const filteredAll = getFilteredFlights(flights, filters);

  // ONWARD FILTERED LIST
  const filteredOnward = useMemo(() => {
    return getFilteredFlights(onwardFlights, onwardFilters);
  }, [onwardFlights, onwardFilters]);

  // RETURN FILTERED LIST
  const filteredReturn = useMemo(() => {
    return getFilteredFlights(returnFlights, returnFilters);
  }, [returnFlights, returnFilters]);


  //  Total passenger count
  const totalPax =
    Number(data.adult || 0) +
    Number(data.child || 0) +
    Number(data.infant || 0);

  // Pricing start

  const getLastFare = (flight) => {
    if (!flight?.fares || flight.fares.length === 0) return 0;
    return flight.fares[flight.fares.length - 1]?.totalFare || 0;
  };

  //  all hooks declared here
  const handleBookNow = async (flight, index) => {
    //*********************  oneway   ********************************************
    if (flight?.fares && flight?.trip === 1) {
      //alert(index);
      setShowPopup(false);
      setIslowestFlight(false);
      setFlightType("oneway")
      //setUserSelectedFlight(flight);
      //setUserSelectedFlight(Array.isArray(flight) ? flight : [flight]);
      const selectedFlight = Array.isArray(flight) ? flight[0] : flight;
      //const selectedFlight = Array.isArray(flight) ? flight : [flight];

      if (!selectedFlight?.fares?.[index]) {
        console.error("Fare not found");
        return;
      }
      const updatedFlight = {
        ...selectedFlight,
        fares: [selectedFlight.fares[index]]
      };
      setUserSelectedFlight([updatedFlight]);
      try {
        const departureTime = flight?.segments?.[0]?.departDateTime;

        if (!departureTime) {
          console.error("Departure time not found");
          return;
        }

        const targetTime = new Date(departureTime);
        const startTime = new Date(targetTime.getTime() - 60 * 60 * 1000);
        const endTime = new Date(targetTime.getTime() + 60 * 60 * 1000);

        const onwardSortedFlights = onwardFlights
          ?.filter(f => {
            const depTime = new Date(f?.segments?.[0]?.departDateTime);
            return depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          });

        const bestOnward = onwardSortedFlights?.[0];
        // const highestOnwardFlight = onwardSortedFlights?.[onwardSortedFlights.length - 1];
        let highestFare = 0;
        let highestFareDetails = null;

        onwardSortedFlights.forEach(flight => {
          if (flight.fares && Array.isArray(flight.fares)) {
            flight.fares.forEach(fare => {
              if (fare.totalFare > highestFare) {
                highestFare = fare.totalFare;
                highestFareDetails = {
                  // flightItem: flight.itemNo,
                  // supplier: flight.supplierCode,
                  // airline: flight.validatingCarrier,
                  // fareType: fare.fareType,
                  totalFare: fare.totalFare
                };
              }
            });
          }
        });

        ////console.log("onwardAISelectedFlight",onwardSortedFlights);

        if (!bestOnward) {
          throw new Error("No flight available");
        }
        //const selectedFlightPrice = flight?.fareDetails?.netAmount || 0;
        const selectedFlightPrice = flight?.fares?.[index]?.totalFare || 0;
        const recommendedFlightPrice = bestOnward?.fares?.[0]?.totalFare || 0;

        setSelectedFlightPrice(selectedFlightPrice);
        setRecommendedFlightPrice(recommendedFlightPrice);
        setHighestFlightPrice(highestFareDetails.totalFare);

        // //console.log("Selected:", selectedFlightPrice);
        // //console.log("Recommended:", recommendedFlightPrice);
        // alert(
        //   (Number(selectedFlightPrice) || 0) - (Number(recommendedFlightPrice) || 0)
        // );
        // POPUP CONDITION

        if ((Number(selectedFlightPrice) || 0) <= (Number(recommendedFlightPrice) || 0)) {
          //alert("You already selected the lowest price flight");
          // setRecommendedFlight(Array.isArray(bestOnward) ? bestOnward : [bestOnward]);
          setPendingBooking({ flight, index });
          setShowPopup(true);
          setIslowestFlight(true);
          return;
        }

        if (selectedFlightPrice > recommendedFlightPrice) {
          setPriceDiff(selectedFlightPrice - recommendedFlightPrice);
          //setRecommendedFlight(onwardSelectedFlight);
          setRecommendedFlight(Array.isArray(bestOnward) ? bestOnward : [bestOnward]);
          setPendingBooking({ flight, index });

          setShowPopup(true);
          return;
        }

        // If no popup needed → proceed directly
        await proceedBooking(flight, index, bestOnward);

      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong.");
      }
    }

    //******************** domestic Round trip **********************************
    else if (flight?.onward && flight?.onward.trip === 1 && flight?.return && flight?.return.trip === 1) {
      // alert(flight.onward.selectedFareIndex);
      // alert(flight.return.selectedFareIndex);
      setShowPopup(false);
      setIslowestFlight(false);
      setFlightType("domesticRoundTrip")
      //Note: In roundtrip fare index come onward and return list with name : selectedFareIndex
      const selectedFlight = flight; // already object

      // Validation
      if (!selectedFlight?.onward?.fares?.[flight.onward.selectedFareIndex]) {
        console.error("Onward fare not found");
        return;
      }

      if (!selectedFlight?.return?.fares?.[flight.return.selectedFareIndex]) {
        console.error("Return fare not found");
        return;
      }

      const updatedFlight = {
        ...selectedFlight,
        onward: {
          ...selectedFlight.onward,
          fares: [selectedFlight.onward.fares[flight.onward.selectedFareIndex]]
        },
        return: {
          ...selectedFlight.return,
          fares: [selectedFlight.return.fares[flight.return.selectedFareIndex]]
        }
      };

      setUserSelectedFlight([updatedFlight]);
      //console.log("setUserSelectedFlight", [updatedFlight]);
      try {
        const departureTime = selectedFlight?.onward?.segments?.[0]?.departDateTime;

        if (!departureTime) {
          console.error("Departure time not found");
          return;
        }

        const targetTime = new Date(departureTime);
        const startTime = new Date(targetTime.getTime() - 60 * 60 * 1000);
        const endTime = new Date(targetTime.getTime() + 60 * 60 * 1000);

        const bestOnward = onwardFlights
          ?.filter(f => {
            const depTime = new Date(f?.segments?.[0]?.departDateTime);
            return depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          })?.[0];

        const onwardSortedFlights = onwardFlights
          ?.filter(f => {
            const depTime = new Date(f?.segments?.[0]?.departDateTime);
            return depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          });

        let highestFare = 0;
        let highestFareDetails = null;

        onwardSortedFlights.forEach(flight => {
          if (flight.fares && Array.isArray(flight.fares)) {
            flight.fares.forEach(fare => {
              if (fare.totalFare > highestFare) {
                highestFare = fare.totalFare;
                highestFareDetails = {
                  totalFare: fare.totalFare
                };
              }
            });
          }
        });

        //const highestOnwardFlight = onwardSortedFlights?.[onwardSortedFlights.length - 1];

        if (!bestOnward) {
          throw new Error("No flight available");
        }

        // return
        const returnDepTime = selectedFlight?.return?.segments?.[0]?.departDateTime;

        const returnStart = new Date(new Date(returnDepTime).getTime() - 60 * 60 * 1000);
        const returnEnd = new Date(new Date(returnDepTime).getTime() + 60 * 60 * 1000);

        const bestReturn = returnFlights
          ?.filter(f => {
            const dep = new Date(f?.segments?.[0]?.departDateTime);
            return dep >= returnStart && dep <= returnEnd;
          })
          ?.sort((a, b) => {
            return (a?.fares?.[0]?.totalFare || 0) - (b?.fares?.[0]?.totalFare || 0);
          })?.[0];

        if (!bestReturn) throw new Error("No return flight");

        const returnSortedFlights = returnFlights
          ?.filter(f => {
            const dep = new Date(f?.segments?.[0]?.departDateTime);
            return dep >= returnStart && dep <= returnEnd;
          })
          ?.sort((a, b) => {
            return (a?.fares?.[0]?.totalFare || 0) - (b?.fares?.[0]?.totalFare || 0);
          });

        let highestReturnFare = 0;
        let highestReturnFareDetails = null;

        returnSortedFlights.forEach(flight => {
          if (flight.fares && Array.isArray(flight.fares)) {
            flight.fares.forEach(fare => {
              if (fare.totalFare > highestReturnFare) {
                highestReturnFare = fare.totalFare;
                highestReturnFareDetails = {
                  totalFare: fare.totalFare
                };
              }
            });
          }
        });

        //const highestReturnFlight = returnSortedFlights?.[returnSortedFlights.length - 1];
        //PRICE CALCULATION
        const selectedPrice =
          (selectedFlight?.onward?.fares?.[0]?.totalFare || 0) +
          (selectedFlight?.return?.fares?.[0]?.totalFare || 0);

        const recommendedPrice =
          (bestOnward?.fares?.[0]?.totalFare || 0) +
          (bestReturn?.fares?.[0]?.totalFare || 0);

        const highestFlightPrice = highestFareDetails.totalFare + highestReturnFareDetails.totalFare;

        setSelectedFlightPrice(selectedPrice);
        setRecommendedFlightPrice(recommendedPrice);
        setHighestFlightPrice(highestFlightPrice);
        //COMPARISON
        if (selectedPrice <= recommendedPrice) {
          //alert("You already selected the lowest price flight");
          // alert(selectedPrice);
          // alert(recommendedPrice);
          //return;
          setPendingBooking({ flight, index });
          setShowPopup(true);
          setIslowestFlight(true);
          return;
        }

        if (selectedPrice > recommendedPrice) {
          setPriceDiff(selectedPrice - recommendedPrice);
          setRecommendedFlight([
            {
              onward: bestOnward,
              return: bestReturn
            }
          ]);

          setPendingBooking({ flight, index });
          setShowPopup(true);
          return;
        }

        await proceedBooking(updatedFlight, index, {
          onward: bestOnward,
          return: bestReturn
        });

        //await proceedBooking(updatedFlight, index, recommendedFlight);

      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong.");
      }
    }

    //**********************  international Round trip  **************************
    else if (flight && flight?.trip === 2 && flight?.tripType === 2) {
      //alert("international");
      setShowPopup(false);
      setIslowestFlight(false);
      setFlightType("internationalRoundTrip")
      //Note: In roundtrip fare index come with : selectedFareIndex and  [selectedFare]
      const selectedFlight = flight; // already object

      const updatedFlight = {
        ...selectedFlight,
        fares: [selectedFlight.selectedFare]
      };

      setUserSelectedFlight([updatedFlight]);
      //console.log("setUserSelectedFlight", [updatedFlight]);
      try {
        const departureTime = selectedFlight?.segments?.[0]?.departDateTime;

        if (!departureTime) {
          console.error("Departure time not found");
          return;
        }

        const targetTime = new Date(departureTime);
        const startTime = new Date(targetTime.getTime() - 60 * 60 * 1000);
        const endTime = new Date(targetTime.getTime() + 60 * 60 * 1000);

        // for return
        const returnDepartureTime = selectedFlight?.segments?.filter(s => s.flightCount === 2)?.[0]?.departDateTime;

        if (!returnDepartureTime) {
          console.error("return Departure Time not found");
          return;
        }

        const returntargetTime = new Date(returnDepartureTime);
        const returnstartTime = new Date(returntargetTime.getTime() - 60 * 60 * 1000);
        const returnendTime = new Date(returntargetTime.getTime() + 60 * 60 * 1000);

        const bestOnward = returnFlights
          // ?.filter(f => {
          //   const depTime = new Date(f?.segments?.[0]?.departDateTime);
          //   return depTime >= startTime && depTime <= endTime;
          // })
          // ?.map(f => ({
          //   ...f,
          //   fares: (f?.fares || []).sort((a, b) => (a?.totalFare || 0) - (b?.totalFare || 0))
          // }))
          ?.filter(f => {
            const firstSeg = f?.segments?.filter(s => s.flightCount === 1)?.[0];
            const depTime = firstSeg?.departDateTime ? new Date(firstSeg.departDateTime) : null;

            return depTime && depTime >= startTime && depTime <= endTime;
          })
          // ?.filter(f => {
          //   const returnfirstSeg = f?.segments?.filter(s => s.flightCount === 2)?.[0];
          //   const returndepTime = returnfirstSeg?.departDateTime ? new Date(returnfirstSeg.departDateTime) : null;

          //   return returndepTime && returndepTime >= returnstartTime && returndepTime <= returnendTime;
          // })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            // const priceA = Math.min(...(a?.fares || []).map(f => f?.totalFare || 0));
            // const priceB = Math.min(...(b?.fares || []).map(f => f?.totalFare || 0));

            return priceA - priceB;
          })?.[0];

        if (!bestOnward) {
          throw new Error("No flight available");
        }

        const SortedFlights = returnFlights
          ?.filter(f => {
            const firstSeg = f?.segments?.filter(s => s.flightCount === 1)?.[0];
            const depTime = firstSeg?.departDateTime ? new Date(firstSeg.departDateTime) : null;

            return depTime && depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          });

        let highestFare = 0;
        let highestFareDetails = null;

        SortedFlights.forEach(flight => {
          if (flight.fares && Array.isArray(flight.fares)) {
            flight.fares.forEach(fare => {
              if (fare.totalFare > highestFare) {
                highestFare = fare.totalFare;
                highestFareDetails = {
                  totalFare: fare.totalFare
                };
              }
            });
          }
        });
        //const highestSortedFlight = SortedFlights?.[SortedFlights.length - 1];
        const highestFlightPrice = highestFareDetails.totalFare;

        //PRICE CALCULATION
        //console.log("selectedFlight:::::::", selectedFlight);
        const selectedPrice = (selectedFlight?.selectedFare?.totalFare || 0);

        const recommendedPrice = (bestOnward?.fares?.[0]?.totalFare || 0);

        setSelectedFlightPrice(selectedPrice);
        setRecommendedFlightPrice(recommendedPrice);
        setHighestFlightPrice(highestFlightPrice);

        //COMPARISON
        setRecommendedFlight(null);

        if (selectedPrice <= recommendedPrice) {
          //alert("You already selected the lowest price flight");
          setPendingBooking({ flight, index });
          setShowPopup(true);
          setIslowestFlight(true);
          return;
        }

        if (selectedPrice > recommendedPrice) {
          setPriceDiff(selectedPrice - recommendedPrice);
          setRecommendedFlight([
            {
              onward: bestOnward,
              //return: bestReturn
            }
          ]);

          setPendingBooking({ flight, index });
          setShowPopup(true);
          return;
        }

        await proceedBooking(updatedFlight, index, {
          onward: bestOnward,
          //return: bestReturn
        });

      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong.");
      }
    }

    //**********************  international One Way trip  **************************
    else if (flight && flight?.trip === 2 && flight?.tripType === 1) {
      //alert("In one way");
      setShowPopup(false);
      setIslowestFlight(false);
      setFlightType("internationalOneWayTrip")
      //Note: In roundtrip fare index come with : selectedFareIndex and  [selectedFare]
      const selectedFlight = flight; // already object

      if (!selectedFlight?.fares?.[index]) {
        console.error("Fare not found");
        return;
      }
      const updatedFlight = {
        ...selectedFlight,
        fares: [selectedFlight.fares[index]]
      };

      // const updatedFlight = {
      //   ...selectedFlight,
      //   fares: [selectedFlight.selectedFare]
      // };

      setUserSelectedFlight([updatedFlight]);
      //console.log("setUserSelectedFlight", [updatedFlight]);
      try {
        const departureTime = selectedFlight?.segments?.[0]?.departDateTime;

        if (!departureTime) {
          console.error("Departure time not found");
          return;
        }

        const targetTime = new Date(departureTime);
        const startTime = new Date(targetTime.getTime() - 60 * 60 * 1000);
        const endTime = new Date(targetTime.getTime() + 60 * 60 * 1000);

        const bestOnward = onwardFlights
          ?.filter(f => {
            const depTime = new Date(f?.segments?.[0]?.departDateTime);
            return depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          })?.[0];

        const OnwardSortedFlight = onwardFlights
          ?.filter(f => {
            const depTime = new Date(f?.segments?.[0]?.departDateTime);
            return depTime >= startTime && depTime <= endTime;
          })
          ?.sort((a, b) => {
            const priceA = a?.fares?.[0]?.totalFare || 0;
            const priceB = b?.fares?.[0]?.totalFare || 0;
            return priceA - priceB;
          });

        let highestFare = 0;
        let highestFareDetails = null;

        OnwardSortedFlight.forEach(flight => {
          if (flight.fares && Array.isArray(flight.fares)) {
            flight.fares.forEach(fare => {
              if (fare.totalFare > highestFare) {
                highestFare = fare.totalFare;
                highestFareDetails = {
                  totalFare: fare.totalFare
                };
              }
            });
          }
        });
        const highestFlightPrice = highestFareDetails.totalFare;

        if (!bestOnward) {
          throw new Error("No flight available");
        }

        //PRICE CALCULATION
        //        //console.log("selectedFlight:::::::", selectedFlight);
        const selectedPrice = (selectedFlight?.fares?.[0]?.totalFare || 0);

        const recommendedPrice =
          (bestOnward?.fares?.[0]?.totalFare || 0);;

        setSelectedFlightPrice(selectedPrice);
        setRecommendedFlightPrice(recommendedPrice);
        setHighestFlightPrice(highestFlightPrice);

        // alert(selectedPrice);
        // alert(recommendedPrice);
        //COMPARISON
        if (selectedPrice <= recommendedPrice) {
          //alert("You already selected the lowest price flight");
          setPendingBooking({ flight, index });
          setShowPopup(true);
          setIslowestFlight(true);
          return;
        }

        if (selectedPrice > recommendedPrice) {
          setPriceDiff(selectedPrice - recommendedPrice);
          setRecommendedFlight([
            {
              onward: bestOnward,
              //return: bestReturn
            }
          ]);

          setPendingBooking({ flight, index });
          setShowPopup(true);
          return;
        }

        await proceedBooking(updatedFlight, index, {
          onward: bestOnward,
          //return: bestReturn
        });

      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong.");
      }
    }

    //************************ multicity *****************************************
    else {
      alert("multicity");
    }
  };

  const proceedBooking = useCallback(async (flight, index, bestlowFareFlight) => {
    try {
      setLoadingFlightIndex(index);
      setPricingLoading(true);

      await new Promise((r) => setTimeout(r, 100));

      let updatedFlight;
      if (flightType === "oneway") {
        updatedFlight = {
          ...flight,
          selectedFare: flight?.fares?.[index]
        };
      } else {
        updatedFlight = {
          ...flight
        };
      }

      const Journey = "Onward";
      const ClassOfService = "E";

      const response = await flightPricing(
        "BerryJourneys",
        userName,
        guidNo,
        corporateId,
        updatedFlight,
        Journey,
        ClassOfService,
        flightRequst
      );

      if (response?.status === "Success" && !response.isPriceChange) {
        try {
          const finalFlight = bestlowFareFlight || recommendedFlight;
          if (!finalFlight) {
            console.warn("No recommended flight found");
          }
          const requestBody = {
            OnwardSortedFlight: bestlowFareFlight?.onward ? JSON.stringify(bestlowFareFlight.onward) : bestlowFareFlight ? JSON.stringify(bestlowFareFlight) : "",
            ReturnSortedFlight: bestlowFareFlight?.return ? JSON.stringify(bestlowFareFlight.return) : bestlowFareFlight ? "" : "",
            ReferenceNo: response.referenceNo,
            SelectedOption: selectedOption,
            SelectedFlightPrice: Number(selectedFlightPrice),
            RecommendedFlightPrice: Number(recommendedFlightPrice),
            HighestFlightPrice: Number(highestFlightPrice),
            Remark: (remark === "Other") ? otherRemark : remark,
          };

          await SaveApprovalLowFareFlights(requestBody);
        } catch (error) {
          console.error("SaveApproval error:", error);
        }

        navigate(`/Flight/booking?ReferenceNo=${response.referenceNo}&ClientCode=BerryJourneys&Key=${response.key}`);
        return;
      }

      if (response?.isPriceChange) {
        alert("The fare has increased.");
      } else {
        alert(response?.error?.description || "Fare not found.");
      }

    } catch (error) {
      console.error("Pricing error:", error);
      alert("Unable to fetch price.");
    } finally {
      setPricingLoading(false);
      setLoadingFlightIndex(null);
    }
  }, [selectedFlightPrice,
    recommendedFlightPrice,
    highestFlightPrice,
    recommendedFlight,
    selectedOption,
    remark,
    otherRemark,
    flightType,
    // userName,
    // guidNo,
    // corporateId,
    // flightRequst,
  ]);

  const calcDuration = (start, end) => {
    if (!start || !end) return "—";
    const s = new Date(start);
    const e = new Date(end);
    const diff = Math.abs(e - s) / 1000 / 60;
    const h = Math.floor(diff / 60);
    const m = diff % 60;
    return `${h}h ${m}m`;
  };

  const validate = () => {
    let newErrors = {
      remark: "",
      otherRemark: ""
    };
    // alert(selectedOption);
    if (selectedOption === "original") {
      if (!remark) {
        newErrors.remark = "Please select remark";
      }
      if (remark === "Other" && !otherRemark.trim()) {
        newErrors.otherRemark = "Please enter remark";
      }
    }
    setErrors(newErrors);
    return !newErrors.remark && !newErrors.otherRemark;
  };

  return (
    <>
      {pricingLoading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <Header />
      <section class="wrapers results">
        <div class="row">
          {showPopup && (
            <div className="col-md-12 fareCompare">
              {pricingLoading && (
                <p class="text-center load"><span class="loader"></span></p>
              )}
              <div className="fareCompare_d">
                <i className="fa fa-close clickToClose"
                  onClick={() => setShowPopup(false)}
                  style={{ cursor: "pointer" }}
                ></i>
                <div className="row">
                  <div className="col-md-12">
                    <h3 class="sub_heading">Low Fare Check</h3>
                    {islowestFlight && (
                      <p style={{ color: "green" }}>You already selected the lowest price flight</p>
                    )}
                  </div>
                  {/* <div className="col-md-6">
                     <h3 class="sub_heading">Selected Flight | price <i className="fa fa-inr">
                  </i>{Number(userSelectedFlight?.[0]?.fares?.[0]?.totalFare || userSelectedFlight.fare?.totalFare || 0)}</h3>
                  </div> */}
                </div>
                {/* One Way */}
                {Array.isArray(userSelectedFlight) && userSelectedFlight?.[0]?.trip === 1 && (
                  <>
                    {Array.isArray(userSelectedFlight) &&
                      userSelectedFlight.map((f, idx) => {
                        const seg = f?.segments?.[0];

                        const segments = f.segments || [];

                        // Safety check
                        const firstSeg = segments[0] || {};
                        const lastSeg = segments[segments.length - 1] || {};

                        // Flight Info
                        const airLineCode =
                          f.airLineCode || firstSeg.airLineCode || "";
                        const airLineName =
                          firstSeg.airLineName ||
                          firstSeg.airlineName ||
                          firstSeg.carrierName ||
                          "Unknown Airline";
                        const flightNumber =
                          f.flightNumber || firstSeg.flightNumber || "";

                        // Locations
                        const origin =
                          firstSeg.departAirportCode || f.departAirportCode || f.org || "";
                        const destination =
                          lastSeg.arrivalAirportCode || f.arrivalAirportCode || f.dest || "";

                        // Timing (THIS IS THE MAIN FIX)
                        const departTime =
                          firstSeg.departDateTime || f.departDateTime || "";
                        const arrivalTime =
                          lastSeg.arrivalDateTime || f.arrivalDateTime || "";

                        // Stops (correct for all cases)
                        const stops =
                          segments.length > 0 ? segments.length - 1 : 0;

                        // Duration (correct end-to-end)
                        const [hours, minutes] = f.totalDuration.split(":");
                          const h = parseInt(hours);
                          const m = parseInt(minutes);

                          const totalDuration =
                            `${h > 0 ? h + "h " : ""}${m > 0 ? m + "m" : ""}`.trim();
                        // const totalDuration =
                        //   f.journeyDuration ||
                        //   calcDuration(departTime, arrivalTime);

                        // Fare Info
                        const totalFare =
                          Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);
                        const isRefundable =
                          f.fares?.[0]?.isRefundable ?? false;

                        return (
                          <div key={idx} className="result_repeat mb-2">
                            <div className="row">
                              {/* Left Section */}
                              <div className="col-md-8 col-lg-8">
                                <div className="row">
                                  <div className="col-md-4 col-lg-4">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4">
                                        <div className="flight_img">
                                          <div>
                                            <img
                                              src={`/assets/images/Flight_Images/${f.segments[0].airLineCode}.gif`}
                                              alt={f.segments[0].airLineName}
                                              width="50"
                                            />
                                          </div>

                                        </div>
                                      </div>
                                      <div className="col-md-8 col-lg-8">
                                        <figure className="flight_sect">
                                          <span className="airlineImage">
                                            {f?.segments?.[0]?.airLineName}
                                          </span>

                                          {f?.segments?.map((seg, i) => (
                                            <span className="multi_flgt" key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < f.segments.length - 1 && " || "}
                                            </span>
                                          ))}
                                        </figure>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 col-lg-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(departTime)}</h4>
                                          <p>{origin}</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-lg-3 col-3">
                                        <div className="deruation">
                                          <p>{totalDuration}</p>
                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">{stops} stop</p>
                                        </div>
                                      </div>
                                      <div className="col-md-4 col-lg-4 offset-1 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(arrivalTime)}</h4>
                                          <p>{destination}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Right Price Section */}
                              <div className="col-md-4 col-lg-4">
                                <div className="price_view">
                                  <div className="row">
                                    <div className="col-md-6 col-lg-6">
                                      <div className="flight_charge">

                                        <div className="flight_charge">
                                          <i className="fa fa-inr"></i>
                                          {
                                            selectedFareMap[f?.itemNo]?.totalFare?.toLocaleString("en-IN") ||
                                            f?.fares?.[0]?.totalFare?.toLocaleString("en-IN") ||
                                            0
                                          }

                                          <p className="type_frs">
                                            {
                                              selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ||
                                              f?.fares?.[0]?.journeyFareInfos?.[0]?.type ||
                                              "Regular"
                                            }
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6">
                                      <h2 className="selected">Selected</h2>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {f.segments.map((segment, index) => (
                                <div key={index}>

                                </div>
                              ))}
                              {/* Footer Info */}
                              <div className="col-md-12 col-lg-12">
                                <ul className="list_service">
                                  <li>
                                    <div className="d-flex">
                                      <div className="equipmentType">
                                        <i className="fa-solid fa-fan"></i>
                                        <span>{f.segments[0].equipmentType}</span>
                                      </div>

                                      <div className="equipmentType">
                                        <img
                                          className="seats"
                                          src="/assets/images/seat.png"
                                          alt="seat"
                                        />
                                        <span>{f.segments[0].availableSeats} Seats</span>
                                      </div>
                                    </div>

                                  </li>
                                  <li className="refundable">

                                    {isRefundable ? (
                                      <span style={{ color: "green" }}><i className="fa fa-inr" style={{ color: "green" }}></i> Refundable</span>
                                    ) : (
                                      <span style={{ color: "red" }}><i className="fa fa-inr" style={{ color: "red" }}></i> Non-Refundable</span>
                                    )}

                                  </li>
                                </ul>
                              </div>
                            </div>

                          </div>
                        );
                      })}
                    {/* <p class="sub_heading">Recommended Flight | price <i className="fa fa-inr"></i>
                    {Number(recommendedFlight?.[0]?.fares?.[0]?.totalFare || recommendedFlight.fare?.totalFare || 0)} | <span style={{ color: "green" }}> Save <i className="fa fa-inr" style={{ color: "green" }}></i> {Number(priceDiff || 0)}</span></p> */}

                    {Array.isArray(recommendedFlight) &&
                      recommendedFlight.map((f, idx) => {
                        const seg = f?.segments?.[0];

                        const segments = f.segments || [];

                        // Safety check
                        const firstSeg = segments[0] || {};
                        const lastSeg = segments[segments.length - 1] || {};

                        // Flight Info
                        const airLineCode =
                          f.airLineCode || firstSeg.airLineCode || "";
                        const airLineName =
                          firstSeg.airLineName ||
                          firstSeg.airlineName ||
                          firstSeg.carrierName ||
                          "Unknown Airline";
                        const flightNumber =
                          f.flightNumber || firstSeg.flightNumber || "";

                        // Locations
                        const origin =
                          firstSeg.departAirportCode || f.departAirportCode || f.org || "";
                        const destination =
                          lastSeg.arrivalAirportCode || f.arrivalAirportCode || f.dest || "";

                        // Timing (THIS IS THE MAIN FIX)
                        const departTime =
                          firstSeg.departDateTime || f.departDateTime || "";
                        const arrivalTime =
                          lastSeg.arrivalDateTime || f.arrivalDateTime || "";

                        // Stops (correct for all cases)
                        const stops =
                          segments.length > 0 ? segments.length - 1 : 0;

                        // Duration (correct end-to-end)
                        const totalDuration =
                          f.journeyDuration ||
                          calcDuration(departTime, arrivalTime);

                        // Fare Info
                        const totalFare =
                          Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);
                        const isRefundable =
                          f.fares?.[0]?.isRefundable ?? false;

                        return (
                          <div key={idx} className="result_repeat mb-2">
                            <div className="row">
                              {/* Left Section */}
                              <div className="col-md-8 col-lg-8">
                                <div className="row">
                                  <div className="col-md-4 col-lg-4">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4">
                                        <div className="flight_img">
                                          <div>
                                            <img
                                              src={`/assets/images/Flight_Images/${f.segments[0].airLineCode}.gif`}
                                              alt={f.segments[0].airLineName}
                                              width="50"
                                            />
                                          </div>

                                        </div>
                                      </div>
                                      <div className="col-md-8 col-lg-8">
                                        <figure className="flight_sect">
                                          <span className="airlineImage">
                                            {f?.segments?.[0]?.airLineName}
                                          </span>

                                          {f?.segments?.map((seg, i) => (
                                            <span className="multi_flgt" key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < f.segments.length - 1 && " || "}
                                            </span>
                                          ))}
                                        </figure>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 col-lg-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(departTime)}</h4>
                                          <p>{origin}</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3 col-lg-3 col-3">
                                        <div className="deruation">
                                          <p>{totalDuration}</p>
                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">{stops} stop</p>
                                        </div>
                                      </div>
                                      <div className="col-md-4 col-lg-4 offset-1 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(arrivalTime)}</h4>
                                          <p>{destination}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Right Price Section */}
                              <div className="col-md-4 col-lg-4">
                                <div className="price_view">
                                  <div className="row">
                                    <div className="col-md-6 col-lg-6">
                                      <div className="flight_charge">

                                        <div className="flight_charge">
                                          <i className="fa fa-inr"></i>
                                          {
                                            selectedFareMap[f?.itemNo]?.totalFare?.toLocaleString("en-IN") ||
                                            f?.fares?.[0]?.totalFare?.toLocaleString("en-IN") ||
                                            0
                                          }

                                          <p className="type_frs">
                                            {
                                              selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ||
                                              f?.fares?.[0]?.journeyFareInfos?.[0]?.type ||
                                              "Regular"
                                            }
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6">
                                      <h2 className="selected_s">Recommended</h2>
                                      <div className="saVepe">
                                        Save <i className="fa fa-inr"></i> {Number(priceDiff || 0)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {f.segments.map((segment, index) => (
                                <div key={index}>

                                </div>
                              ))}
                              {/* Footer Info */}
                              <div className="col-md-12 col-lg-12">
                                <ul className="list_service">
                                  <li>
                                    <div className="d-flex">
                                      <div className="equipmentType">
                                        <i className="fa-solid fa-fan"></i>
                                        <span>{f.segments[0].equipmentType}</span>
                                      </div>

                                      <div className="equipmentType">
                                        <img
                                          className="seats"
                                          src="/assets/images/seat.png"
                                          alt="seat"
                                        />
                                        <span>{f.segments[0].availableSeats} Seats</span>
                                      </div>
                                    </div>
                                  </li>
                                  <li className="refundable">
                                    {isRefundable ? (
                                      <span style={{ color: "green" }}><i className="fa fa-inr" style={{ color: "green" }}></i> Refundable</span>
                                    ) : (
                                      <span style={{ color: "red" }}><i className="fa fa-inr" style={{ color: "red" }}></i> Non-Refundable</span>
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </>
                )}

                {/* Round Trip Domestic */}
                {userSelectedFlight &&
                  userSelectedFlight.length > 0 &&
                  userSelectedFlight?.[0]?.onward?.trip === 1 && (
                    <>
                      <p class="sub_heading">Selected Flight | price <i className="fa fa-inr">
                      </i>{Number(userSelectedFlight?.[0]?.onward?.fares?.[0]?.totalFare) + Number(userSelectedFlight?.[0]?.return?.fares?.[0]?.totalFare)}</p>
                      <div className="result_repeat mb-2">
                        {/* ONWARD FLIGHT */}
                        {(() => {
                          const segments = userSelectedFlight?.[0]?.onward?.segments || [];
                          const firstSeg = segments[0] || {};
                          const lastSeg = segments[segments.length - 1] || {};
                          const stops = segments.length > 0 ? segments.length - 1 : 0;
                          return (
                            <div className="onWords selected-flight">
                              <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                              <div className="prodct_lst_round">
                                <div className="item_bx">
                                  <div className="flight_img_round">
                                    <img
                                      className="flight_i"
                                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                                      alt={firstSeg?.airLineName || ""}
                                    />
                                  </div>

                                  <div className="flight_se">
                                    <span>{firstSeg?.airLineName}</span>
                                    {segments?.map((seg, i) => (
                                      <span className="multi_flgt" key={i}>
                                        {seg.airLineCode}-{seg.flightNumber}
                                        {i < segments.length - 1 && " || "}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                <div className="item_bx">
                                  <div className="timer">
                                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                                    <p>{firstSeg?.departCityName}</p>
                                  </div>
                                </div>

                                <div className="item_bx">
                                  <div className="deruation">
                                    <p>{userSelectedFlight?.[0]?.onward?.totalDuration}</p>
                                    <div className="bordr_top">
                                      <i className="fa fa-plane"></i>
                                    </div>
                                    <p className="stops">
                                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                                    </p>
                                  </div>
                                </div>

                                <div className="item_bx text-center">
                                  <div className="timer">
                                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                                    <p>{lastSeg?.arrivalCityName}</p>
                                  </div>
                                </div>

                                <div className="item_bx text-center">
                                  <div className="flight_charge">
                                    <i className="fa fa-inr"></i>{userSelectedFlight?.[0]?.onward?.fares?.[0]?.totalFare}
                                  </div>
                                </div>

                                {/* <div className="item_bx text-center">
                                  <div className="col-md-6 col-lg-6">
                                      <h2 className="selected">Selected</h2>
                                    </div>
                                </div> */}

                              </div>
                            </div>
                          );
                        })()}

                        {/* RETURN FLIGHT */}
                        {(() => {
                          const segments = userSelectedFlight?.[0]?.return?.segments || [];
                          const firstSeg = segments[0] || {};
                          const lastSeg = segments[segments.length - 1] || {};
                          const stops = segments.length > 0 ? segments.length - 1 : 0;

                          return (
                            <div className="retrnWords">
                              <p className="departure"><i className="fa fa-plane"></i> Return</p>
                              <div className="prodct_lst_round">
                                <div className="item_bx">
                                  <div className="flight_img_round">
                                    <img
                                      className="flight_i"
                                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                                      alt={firstSeg?.airLineName || ""}
                                    />
                                  </div>

                                  <div className="flight_se">
                                    <span>{firstSeg?.airLineName}</span>
                                    {segments?.map((seg, i) => (
                                      <span className="multi_flgt" key={i}>
                                        {seg.airLineCode}-{seg.flightNumber}
                                        {i < segments.length - 1 && " || "}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                <div className="item_bx">
                                  <div className="timer">
                                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                                    <p>{firstSeg?.departCityName}</p>
                                  </div>
                                </div>

                                <div className="item_bx">
                                  <div className="deruation">
                                    <p>{userSelectedFlight?.[0]?.return?.totalDuration}</p>
                                    <div className="bordr_top">
                                      <i className="fa fa-plane"></i>
                                    </div>
                                    <p className="stops">
                                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                                    </p>
                                  </div>
                                </div>

                                <div className="item_bx text-center">
                                  <div className="timer">
                                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                                    <p>{lastSeg?.arrivalCityName}</p>
                                  </div>
                                </div>
                                <div className="item_bx text-center">
                                  <div className="flight_charge">
                                    <i className="fa fa-inr"></i>{userSelectedFlight?.[0]?.return?.fares?.[0]?.totalFare}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                      {recommendedFlight != null && (
                        <>
                          <p class="sub_heading">Recommended Flight | price <i className="fa fa-inr"></i>
                            {Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare) + Number(recommendedFlight?.[0]?.return?.fares?.[0]?.totalFare)} | <span style={{ color: "green" }}> Save <i className="fa fa-inr" style={{ color: "green" }}></i> {(Number(userSelectedFlight?.[0]?.onward?.fares?.[0]?.totalFare) + Number(userSelectedFlight?.[0]?.return?.fares?.[0]?.totalFare)) - (Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare) + Number(recommendedFlight?.[0]?.return?.fares?.[0]?.totalFare))}</span></p>
                          <div className="result_repeat mb-2">
                            {/* ONWARD FLIGHT */}
                            {(() => {
                              const segments = recommendedFlight?.[0]?.onward?.segments || [];
                              const firstSeg = segments[0] || {};
                              const lastSeg = segments[segments.length - 1] || {};
                              const stops = segments.length > 0 ? segments.length - 1 : 0;
                              return (
                                <div className="onWords selected-flight">
                                  <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                  <div className="prodct_lst_round">
                                    <div className="item_bx">
                                      <div className="flight_img_round">
                                        <img
                                          className="flight_i"
                                          src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                                          alt={firstSeg?.airLineName || ""}
                                        />
                                      </div>

                                      <div className="flight_se">
                                        <span>{firstSeg?.airLineName}</span>
                                        {segments?.map((seg, i) => (
                                          <span className="multi_flgt" key={i}>
                                            {seg.airLineCode}-{seg.flightNumber}
                                            {i < segments.length - 1 && " || "}
                                          </span>
                                        ))}
                                      </div>
                                    </div>

                                    <div className="item_bx">
                                      <div className="timer">
                                        <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                                        <p>{firstSeg?.departCityName}</p>
                                      </div>
                                    </div>

                                    <div className="item_bx">
                                      <div className="deruation">
                                        <p>{recommendedFlight?.[0]?.onward?.totalDuration}</p>
                                        <div className="bordr_top">
                                          <i className="fa fa-plane"></i>
                                        </div>
                                        <p className="stops">
                                          {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="item_bx text-center">
                                      <div className="timer">
                                        <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                                        <p>{lastSeg?.arrivalCityName}</p>
                                      </div>
                                    </div>

                                    <div className="item_bx text-center">
                                      <div className="flight_charge">
                                        <i className="fa fa-inr"></i>{recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}

                            {/* RETURN FLIGHT */}
                            {(() => {
                              const segments = recommendedFlight?.[0]?.return?.segments || [];
                              const firstSeg = segments[0] || {};
                              const lastSeg = segments[segments.length - 1] || {};
                              const stops = segments.length > 0 ? segments.length - 1 : 0;

                              return (
                                <div className="retrnWords">
                                  <p className="departure"><i className="fa fa-plane"></i> Return</p>
                                  <div className="prodct_lst_round">
                                    <div className="item_bx">
                                      <div className="flight_img_round">
                                        <img
                                          className="flight_i"
                                          src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                                          alt={firstSeg?.airLineName || ""}
                                        />
                                      </div>

                                      <div className="flight_se">
                                        <span>{firstSeg?.airLineName}</span>
                                        {segments?.map((seg, i) => (
                                          <span className="multi_flgt" key={i}>
                                            {seg.airLineCode}-{seg.flightNumber}
                                            {i < segments.length - 1 && " || "}
                                          </span>
                                        ))}
                                      </div>
                                    </div>

                                    <div className="item_bx">
                                      <div className="timer">
                                        <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                                        <p>{firstSeg?.departCityName}</p>
                                      </div>
                                    </div>

                                    <div className="item_bx">
                                      <div className="deruation">
                                        <p>{recommendedFlight?.[0]?.return?.totalDuration}</p>
                                        <div className="bordr_top">
                                          <i className="fa fa-plane"></i>
                                        </div>
                                        <p className="stops">
                                          {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                                        </p>
                                      </div>
                                    </div>

                                    <div className="item_bx text-center">
                                      <div className="timer">
                                        <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                                        <p>{lastSeg?.arrivalCityName}</p>
                                      </div>
                                    </div>
                                    <div className="item_bx text-center">
                                      <div className="flight_charge">
                                        <i className="fa fa-inr"></i>{recommendedFlight?.[0]?.return?.fares?.[0]?.totalFare}
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        </>
                      )}
                    </>
                  )}

                {/* Round Trip International */}
                {userSelectedFlight &&
                  userSelectedFlight.length > 0 &&
                  userSelectedFlight?.[0]?.trip === 2 && userSelectedFlight?.[0]?.tripType === 2 && (
                    <>
                      <p class="sub_heading">Selected Flight | price <i className="fa fa-inr">
                      </i>{Number(userSelectedFlight?.[0]?.selectedFare?.totalFare)}</p>
                      {(() => {
                        const item = userSelectedFlight?.[0];
                        const onwardSegments = item.segments?.filter(x => x.flightCount === 1) || [];
                        const returnSegments = item.segments?.filter(x => x.flightCount === 2) || [];

                        const onwardFirst = onwardSegments[0];
                        const onwardLast = onwardSegments[onwardSegments.length - 1];

                        const returnFirst = returnSegments[0];
                        const returnLast = returnSegments[returnSegments.length - 1];

                        return (
                          <div className="result_repeat mb-3" key={0}>
                            <div className="row">
                              {/* ---------- LEFT SIDE (FLIGHT DETAILS) ---------- */}
                              <div className="col-md-9">
                                {/* ----- ONWARD ----- */}
                                <div className="row oneWay_flight_1">
                                  <p className="mode_trvel">
                                    <span>
                                      <i className="fa fa-plane"></i> Departure
                                    </span>
                                  </p>

                                  <div className="col-md-4 col-lg-4">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <img
                                          src={`/assets/images/Flight_Images/${onwardFirst?.airLineCode}.gif`}
                                          width="30"
                                          alt=""
                                        />
                                      </div>
                                      <div className="col-md-8">
                                        <span>
                                          {onwardSegments?.map((seg, i) => (
                                            <span key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < onwardSegments.length - 1 && "/"}
                                            </span>
                                          ))}
                                        </span>
                                        <div>{onwardFirst.airLineName}</div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="timer">
                                          <h4>{onwardFirst.departDateTime?.slice(11, 16)}</h4>
                                          <p>{onwardFirst.departAirportCode}</p>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>{item.totalDuration}</p>

                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">
                                            {onwardSegments.length - 1}{" "}
                                            {(onwardSegments.length - 1) === 1 ? "stop" : "stops"}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-4 offset-1">
                                        <div className="timer">
                                          <h4>{onwardLast.arrivalDateTime?.slice(11, 16)}</h4>
                                          <p>{onwardLast.arrivalAirportCode}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ----- RETURN ----- */}
                                <div className="row oneWay_flight_2">
                                  <p className="mode_trvel">
                                    <span>
                                      <i className="fa fa-plane"></i> Return
                                    </span>
                                  </p>

                                  <div className="col-md-4">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <img
                                          src={`/assets/images/Flight_Images/${returnFirst?.airLineCode}.gif`}
                                          width="30"
                                          alt=""
                                        />
                                      </div>
                                      <div className="col-md-8">
                                        <span>
                                          {returnSegments?.map((seg, i) => (
                                            <span key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < returnSegments.length - 1 && "/"}
                                            </span>
                                          ))}
                                        </span>
                                        <div>{returnFirst.airLineName}</div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="timer">
                                          <h4>{returnFirst?.departDateTime?.slice(11, 16)}</h4>
                                          <p>{returnFirst?.departAirportCode}</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>{item.totalDurationReturn}</p>
                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">
                                            {returnSegments.length - 1}{" "}
                                            {(returnSegments.length - 1) === 1 ? "stop" : "stops"}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-4 offset-1">
                                        <div className="timer">
                                          <h4>{returnLast.arrivalDateTime?.slice(11, 16)}</h4>
                                          <p>{returnLast.arrivalAirportCode}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ----- Services / Refundability ----- */}
                                <div className="col-md-12">
                                  <ul className="list_service">

                                    {/* Equipment + Seats */}
                                    <li>
                                      <div className="d-flex">
                                        <div className="equipmentType">
                                          <i className="fa-solid fa-fan"></i>
                                          <span>{onwardFirst?.equipmentType || "-"}</span>
                                        </div>

                                        <div className="equipmentType">
                                          <img
                                            className="seats"
                                            src="/assets/images/seat.png"
                                            alt="seat"
                                          />
                                          <span>{onwardFirst?.availableSeats ?? "-"} Seats</span>
                                        </div>
                                      </div>
                                    </li>

                                    {/* Refundable */}
                                    <li className="refundable">
                                      {item?.fares?.[0]?.isRefundable ? (
                                        <span style={{ color: "green", fontWeight: 500 }}>Refundable</span>
                                      ) : (
                                        <span style={{ color: "red", fontWeight: 500 }}>Non-Refundable</span>
                                      )}
                                    </li>

                                    {/* Flight Details */}
                                    <li className="view_on">
                                      <a
                                        className="flight_details"
                                        role="button"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#FlightDetails"
                                        onClick={() =>
                                          setSelectedFlight({
                                            ...item,
                                            onwardSegments,
                                            returnSegments,
                                            selectedFareIndex: 0
                                          })
                                          //</li>//console.log("setSelectedFlight", returnSegments)
                                        }
                                      >
                                        <i className="fa fa-plane"></i> Flight Details
                                      </a>
                                    </li>


                                  </ul>
                                </div>

                              </div>

                              {/* ---------- RIGHT SIDE (PRICE + BUTTONS) ---------- */}

                              <div className="col-md-3">
                                <div className="price_int">
                                  <p className="type_frs">
                                    {/* {
                      selectedFareMap[item?.fares?.[0]?.fareType] ??
                      "Standard Fare"
                    } */}
                                    {
                                      item?.fares?.[0]?.fareType ??
                                      "Standard Fare"
                                    }
                                  </p>
                                  <div className="cos_int_flight">
                                    <i className="fa fa-inr"></i>{" "}
                                    {/* {formatINR(item?.fares?.[0]?.totalFare)} */}
                                    {(item?.fares?.[0]?.totalFare)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })()}

                      <p class="sub_heading">Recommended Flight | price <i className="fa fa-inr"></i>
                        {Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare)} | <span style={{ color: "green" }}> Save <i className="fa fa-inr" style={{ color: "green" }}></i> {(Number(userSelectedFlight?.[0]?.selectedFare?.totalFare)) - (Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare))}</span></p>
                      {(() => {
                        const item = recommendedFlight?.[0]?.onward;
                        if (!item) return null;

                        const onwardSegments = item.segments?.filter(x => x.flightCount === 1) || [];
                        const returnSegments = item.segments?.filter(x => x.flightCount === 2) || [];

                        const onwardFirst = onwardSegments[0];
                        const onwardLast = onwardSegments[onwardSegments.length - 1];

                        const returnFirst = returnSegments[0];
                        const returnLast = returnSegments[returnSegments.length - 1];
                        return (
                          <div className="result_repeat mb-3" key={0}>
                            <div className="row">
                              {/* ---------- LEFT SIDE (FLIGHT DETAILS) ---------- */}
                              <div className="col-md-9">
                                {/* ----- ONWARD ----- */}
                                <div className="row oneWay_flight_1">
                                  <p className="mode_trvel">
                                    <span>
                                      <i className="fa fa-plane"></i> Departure
                                    </span>
                                  </p>

                                  <div className="col-md-4 col-lg-4">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <img
                                          src={`/assets/images/Flight_Images/${onwardFirst?.airLineCode}.gif`}
                                          width="30"
                                          alt=""
                                        />
                                      </div>
                                      <div className="col-md-8">
                                        <span>
                                          {onwardSegments?.map((seg, i) => (
                                            <span key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < onwardSegments.length - 1 && "/"}
                                            </span>
                                          ))}
                                        </span>
                                        <div>{onwardFirst.airLineName}</div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="timer">
                                          <h4>{onwardFirst.departDateTime?.slice(11, 16)}</h4>
                                          <p>{onwardFirst.departAirportCode}</p>
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>{item.totalDuration}</p>

                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">
                                            {onwardSegments.length - 1}{" "}
                                            {(onwardSegments.length - 1) === 1 ? "stop" : "stops"}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-4 offset-1">
                                        <div className="timer">
                                          <h4>{onwardLast.arrivalDateTime?.slice(11, 16)}</h4>
                                          <p>{onwardLast.arrivalAirportCode}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ----- RETURN ----- */}
                                <div className="row oneWay_flight_2">
                                  <p className="mode_trvel">
                                    <span>
                                      <i className="fa fa-plane"></i> Return
                                    </span>
                                  </p>

                                  <div className="col-md-4">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <img
                                          src={`/assets/images/Flight_Images/${returnFirst?.airLineCode}.gif`}
                                          width="30"
                                          alt=""
                                        />
                                      </div>
                                      <div className="col-md-8">
                                        <span>
                                          {returnSegments?.map((seg, i) => (
                                            <span key={i}>
                                              {seg.airLineCode}-{seg.flightNumber}
                                              {i < returnSegments.length - 1 && "/"}
                                            </span>
                                          ))}
                                        </span>
                                        <div>{returnFirst.airLineName}</div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="timer">
                                          <h4>{returnFirst?.departDateTime?.slice(11, 16)}</h4>
                                          <p>{returnFirst?.departAirportCode}</p>
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="deruation">
                                          <p>{item.totalDurationReturn}</p>
                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">
                                            {returnSegments.length - 1}{" "}
                                            {(returnSegments.length - 1) === 1 ? "stop" : "stops"}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-4 offset-1">
                                        <div className="timer">
                                          <h4>{returnLast.arrivalDateTime?.slice(11, 16)}</h4>
                                          <p>{returnLast.arrivalAirportCode}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ----- Services / Refundability ----- */}
                                <div className="col-md-12">
                                  <ul className="list_service">

                                    {/* Equipment + Seats */}
                                    <li>
                                      <div className="d-flex">
                                        <div className="equipmentType">
                                          <i className="fa-solid fa-fan"></i>
                                          <span>{onwardFirst?.equipmentType || "-"}</span>
                                        </div>

                                        <div className="equipmentType">
                                          <img
                                            className="seats"
                                            src="/assets/images/seat.png"
                                            alt="seat"
                                          />
                                          <span>{onwardFirst?.availableSeats ?? "-"} Seats</span>
                                        </div>
                                      </div>
                                    </li>

                                    {/* Refundable */}
                                    <li className="refundable">
                                      {item?.fares?.[0]?.isRefundable ? (
                                        <span style={{ color: "green", fontWeight: 500 }}>Refundable</span>
                                      ) : (
                                        <span style={{ color: "red", fontWeight: 500 }}>Non-Refundable</span>
                                      )}
                                    </li>

                                    {/* Flight Details */}
                                    <li className="view_on">
                                      <a
                                        className="flight_details"
                                        role="button"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#FlightDetails"
                                        onClick={() =>
                                          setSelectedFlight({
                                            ...item,
                                            onwardSegments,
                                            returnSegments,
                                            selectedFareIndex: 0
                                          })
                                          //</li>//console.log("setSelectedFlight", returnSegments)
                                        }
                                      >
                                        <i className="fa fa-plane"></i> Flight Details
                                      </a>
                                    </li>


                                  </ul>
                                </div>

                              </div>

                              {/* ---------- RIGHT SIDE (PRICE + BUTTONS) ---------- */}

                              <div className="col-md-3">
                                <div className="price_int">
                                  <p className="type_frs">
                                    {/* {
                      selectedFareMap[item?.fares?.[0]?.fareType] ??
                      "Standard Fare"
                    } */}
                                    {
                                      item?.fares?.[0]?.fareType ??
                                      "Standard Fare"
                                    }
                                  </p>
                                  <div className="cos_int_flight">
                                    <i className="fa fa-inr"></i>{" "}
                                    {/* {formatINR(item?.fares?.[0]?.totalFare)} */}
                                    {(item?.fares?.[0]?.totalFare)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    </>
                  )}

                {/* One Way International */}
                {userSelectedFlight &&
                  userSelectedFlight.length > 0 &&
                  userSelectedFlight?.[0]?.trip === 2 && userSelectedFlight?.[0]?.tripType === 1 && (
                    <>
                      {/* <p class="sub_heading">Selected Flight | price <i className="fa fa-inr">
                      </i>{Number(userSelectedFlight?.[0]?.selectedFare?.totalFare)}</p>

                      <p class="sub_heading">Recommended Flight | price <i className="fa fa-inr"></i>
                        {Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare)} | <span style={{ color: "green" }}> Save <i className="fa fa-inr" style={{ color: "green" }}></i> {(Number(userSelectedFlight?.[0]?.selectedFare?.totalFare)) - (Number(recommendedFlight?.[0]?.onward?.fares?.[0]?.totalFare))}</span></p>
                      */}
                      {(() => {
                        const f = userSelectedFlight?.[0];
                        if (!f) return null; //

                        const segments = f?.segments || [];

                        // Safety check
                        const firstSeg = segments[0] || {};
                        const lastSeg = segments[segments.length - 1] || {};

                        // Flight Info
                        const airLineCode = f?.airLineCode || firstSeg?.airLineCode || "";
                        const airLineName =
                          firstSeg?.airLineName ||
                          firstSeg?.airlineName ||
                          firstSeg?.carrierName ||
                          "Unknown Airline";

                        const flightNumber = f?.flightNumber || firstSeg?.flightNumber || "";

                        // Locations
                        const origin =
                          firstSeg?.departAirportCode || f?.departAirportCode || f?.org || "";

                        const destination =
                          lastSeg?.arrivalAirportCode || f?.arrivalAirportCode || f?.dest || "";

                        // Timing
                        const departTime = firstSeg?.departDateTime || f?.departDateTime || "";
                        const arrivalTime = lastSeg?.arrivalDateTime || f?.arrivalDateTime || "";

                        // Stops
                        const stops = segments.length > 0 ? segments.length - 1 : 0;

                        // Duration
                          const [hours, minutes] = f.totalDuration.split(":");
                          const h = parseInt(hours);
                          const m = parseInt(minutes);

                          const totalDuration =
                            `${h > 0 ? h + "h " : ""}${m > 0 ? m + "m" : ""}`.trim();

                        // const totalDuration =
                        //   f?.totalDuration || calcDuration(departTime, arrivalTime);

                        // Fare Info
                        const totalFare = Number(
                          f?.fares?.[0]?.totalFare || f?.fare?.totalFare || 0
                        );

                        const isRefundable = f?.fares?.[0]?.isRefundable ?? false;

                        return (
                          <div className="result_repeat mb-2">
                            <div className="row">
                              {/* Left Section */}
                              <div className="col-md-8 col-lg-8">
                                <div className="row">
                                  <div className="col-md-4 col-lg-4">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4">
                                        <div className="flight_img">
                                          <img
                                            src={`/assets/images/Flight_Images/${airLineCode}.gif`}
                                            alt={airLineName}
                                            width="50"
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-8 col-lg-8">
                                        <figure className="flight_sect">
                                          <span className="airlineImage">
                                            {airLineName}
                                          </span>

                                          {segments.map((seg, i) => (
                                            <span className="multi_flgt" key={i}>
                                              {seg?.airLineCode}-{seg?.flightNumber}
                                              {i < segments.length - 1 && " || "}
                                            </span>
                                          ))}
                                        </figure>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8 col-lg-8 border-left-right">
                                    <div className="row">
                                      <div className="col-md-4 col-lg-4 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(departTime)}</h4>
                                          <p>{origin}</p>
                                        </div>
                                      </div>

                                      <div className="col-md-3 col-lg-3 col-3">
                                        <div className="deruation">
                                          <p>{totalDuration}</p>
                                          <div className="bordr_top">
                                            <i className="fa fa-plane"></i>
                                          </div>
                                          <p className="stops">
                                            {stops} {stops === 1 ? "stop" : "stops"}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-4 col-lg-4 offset-1 col-4">
                                        <div className="timer">
                                          <h4>{formatTime(arrivalTime)}</h4>
                                          <p>{destination}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Right Price Section */}
                              <div className="col-md-4 col-lg-4">
                                <div className="price_view">
                                  <div className="row">
                                    <div className="col-md-6 col-lg-6">
                                      <div className="flight_charge">
                                        <i className="fa fa-inr"></i>
                                        {selectedFareMap?.[f?.itemNo]?.totalFare?.toLocaleString("en-IN") ||
                                          f?.fares?.[0]?.totalFare?.toLocaleString("en-IN") ||
                                          0}

                                        <p className="type_frs">
                                          (
                                          {selectedFareMap?.[f?.itemNo]?.journeyFareInfos?.[0]?.type ||
                                            f?.fares?.[0]?.journeyFareInfos?.[0]?.type ||
                                            "Regular"}
                                          )
                                        </p>
                                      </div>
                                    </div>

                                    <div className="col-md-6 col-lg-6">
                                      <h2 className="selected">Selected</h2>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Footer Info */}
                              <div className="col-md-12 col-lg-12">
                                <ul className="list_service">
                                  <li>
                                    <div className="d-flex">
                                      <div className="equipmentType">
                                        <i className="fa-solid fa-fan"></i>
                                        <span>{firstSeg?.equipmentType}</span>
                                      </div>

                                      <div className="equipmentType">
                                        <img
                                          className="seats"
                                          src="/assets/images/seat.png"
                                          alt="seat"
                                        />
                                        <span>{firstSeg?.availableSeats} Seats</span>
                                      </div>
                                    </div>
                                  </li>

                                  <li className="refundable">
                                    {isRefundable ? (
                                      <span style={{ color: "green" }}>
                                        Refundable
                                      </span>
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        Non-Refundable
                                      </span>
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        );
                      })()}


                      {
                        Array.isArray(recommendedFlight) &&
                        recommendedFlight.map((f, idx) => {
                          const flight = f?.onward || f;
                          const segments = flight?.segments || [];

                          const firstSeg = segments[0] || {};
                          const lastSeg = segments[segments.length - 1] || {};

                          const airLineCode =
                            flight?.airLineCode || firstSeg?.airLineCode || "";

                          const airLineName =
                            firstSeg?.airLineName ||
                            firstSeg?.airlineName ||
                            firstSeg?.carrierName ||
                            "Unknown Airline";

                          const origin =
                            firstSeg?.departAirportCode || flight?.origin || "";

                          const destination =
                            lastSeg?.arrivalAirportCode || flight?.destination || "";

                          const departTime =
                            firstSeg?.departDateTime || flight?.departDateTime || "";

                          const arrivalTime =
                            lastSeg?.arrivalDateTime || flight?.arrivalDateTime || "";

                          const stops = segments.length > 0 ? segments.length - 1 : 0;

                          const totalDuration =
                            flight?.totalDuration ||
                            flight?.journeyDuration ||
                            calcDuration(departTime, arrivalTime);

                          const totalFare = flight?.fares?.[0]?.totalFare || 0;
                          const isRefundable = flight?.fares?.[0]?.isRefundable ?? false;
                          const fareType = flight?.fares?.[0]?.journeyFareInfos?.[0]?.type || "Regular";
                          return (
                            <div key={idx} className="result_repeat mb-2">
                              <div className="row">

                                {/* LEFT */}
                                <div className="col-md-8 col-lg-8">
                                  <div className="row">

                                    <div className="col-md-4 col-lg-4">
                                      <div className="row">

                                        <div className="col-md-4 col-lg-4">
                                          <div className="flight_img">
                                            <img
                                              src={`/assets/images/Flight_Images/${airLineCode}.gif`}
                                              alt={airLineName}
                                              width="50"
                                            />
                                          </div>
                                        </div>

                                        <div className="col-md-8 col-lg-8">
                                          <figure className="flight_sect">
                                            <span className="airlineImage">
                                              {airLineName}
                                            </span>

                                            {segments.map((seg, i) => (
                                              <span className="multi_flgt" key={i}>
                                                {seg?.airLineCode}-{seg?.flightNumber}
                                                {i < segments.length - 1 && " || "}
                                              </span>
                                            ))}
                                          </figure>
                                        </div>

                                      </div>
                                    </div>

                                    <div className="col-md-8 col-lg-8 border-left-right">
                                      <div className="row">

                                        <div className="col-md-4 col-lg-4 col-4">
                                          <div className="timer">
                                            <h4>{formatTime(departTime)}</h4>
                                            <p>{origin}</p>
                                          </div>
                                        </div>

                                        <div className="col-md-3 col-lg-3 col-3">
                                          <div className="deruation">
                                            <p>{totalDuration}</p>
                                            <div className="bordr_top">
                                              <i className="fa fa-plane"></i>
                                            </div>
                                            <p className="stops">
                                              {stops} {stops === 1 ? "stop" : "stops"}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="col-md-4 col-lg-4 offset-1 col-4">
                                          <div className="timer">
                                            <h4>{formatTime(arrivalTime)}</h4>
                                            <p>{destination}</p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  </div>
                                </div>

                                {/* RIGHT */}
                                <div className="col-md-4 col-lg-4">
                                  <div className="price_view">
                                    <div className="row">

                                      <div className="col-md-6 col-lg-6">
                                        <div className="flight_charge">
                                          <i className="fa fa-inr"></i>
                                          {Number(totalFare).toLocaleString("en-IN")}

                                          <p className="type_frs">
                                            {fareType}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="col-md-6 col-lg-6">
                                        <h2 className="selected_s">Recommended</h2>
                                        <div className="saVepe">
                                          Save <i className="fa fa-inr"></i>{" "}
                                          {Number(priceDiff || 0).toLocaleString("en-IN")}
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                {/* FOOTER */}
                                <div className="col-md-12 col-lg-12">
                                  <ul className="list_service">

                                    <li>
                                      <div className="d-flex">
                                        <div className="equipmentType">
                                          <i className="fa-solid fa-fan"></i>
                                          <span>{firstSeg?.equipmentType}</span>
                                        </div>

                                        <div className="equipmentType">
                                          <img
                                            className="seats"
                                            src="/assets/images/seat.png"
                                            alt="seat"
                                          />
                                          <span>{firstSeg?.availableSeats || 0} Seats</span>
                                        </div>
                                      </div>
                                    </li>

                                    <li className="refundable">
                                      {isRefundable ? (
                                        <span style={{ color: "green" }}>
                                          Refundable
                                        </span>
                                      ) : (
                                        <span style={{ color: "red" }}>
                                          Non-Refundable
                                        </span>
                                      )}
                                    </li>

                                  </ul>
                                </div>

                              </div>
                            </div>
                          );
                        })
                      }
                    </>
                  )}

                {!islowestFlight && (
                  <>
                    <div className="col-md-12 mt-5 mb-3">
                      <div className="row">
                        <div className="form-check form-check-inline col-md-5">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="recommended"
                            name="flightOption"
                            value="recommended"
                            checked={selectedOption === "recommended"}
                            onChange={(e) => setSelectedOption(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="recommended">
                            Continue with Recommended
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 mb-5">
                      <div className="row">
                        <div className="form-check form-check-inline col-md-5">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="original"
                            name="flightOption"
                            value="original"
                            checked={selectedOption === "original"}
                            onChange={(e) => {
                              setSelectedOption(e.target.value);
                              setRemark("");
                              setOtherRemark("");
                            }}
                          />
                          <label className="form-check-label" htmlFor="original">
                            Continue with my Original choice
                          </label>
                        </div>
                      </div>
                    </div>

                    {selectedOption === "original" && (
                      <div className="col-md-12 mb-5">
                        <div className="row">
                          <div className="form-check form-check-inline col-md-5">
                            <label className="form-check-label">
                              Remark
                            </label>
                            <select
                              className="form-select"
                              onChange={(e) => {
                                setRemark(e.target.value);
                                setErrors({ ...errors, remark: "" });
                              }}
                            >
                              <option value="">--Select--</option>
                              <option value="Does not Suit with my schedule">Does not Suit with my schedule</option>
                              <option value="Airline Preference">Airline Preference</option>
                              <option value="Safety and Security">Safety and Security</option>
                              <option value="Travelling with Client">Travelling with Client</option>
                              <option value="Travelling with Seniors">Travelling with Seniors</option>
                              <option value="Other">Other</option>
                            </select>
                            {errors.remark && (
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {errors.remark}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {remark === "Other" && selectedOption === "original" && (
                      <div className="col-md-12 mb-5">
                        <div className="row">
                          <div className="form-check form-check-inline col-md-12">

                            <label className="form-check-label">
                              Enter Remark
                            </label>

                            <textarea
                              className="form-controls"
                              rows="3"
                              placeholder="Enter your remark"
                              value={otherRemark}
                              onChange={(e) => {
                                setOtherRemark(e.target.value);
                                setErrors({ ...errors, otherRemark: "" });
                              }}
                            />
                            {errors.otherRemark && (
                              <p style={{ color: "red", marginTop: "5px" }}>
                                {errors.otherRemark}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div class="button-list">
                  <a class="btn-btn-border" href="/flight">Back To Search</a>
                  <button
                    className="btn btn-primary"
                    onClick={async () => {
                      if (!pendingBooking) return;

                      //Validation
                      //if (!validate()) return;
                      if (!validate()) {
                        document.querySelector(".border-danger")?.scrollIntoView({
                          behavior: "smooth",
                          block: "center"
                        });
                        return;
                      }

                      let finalFlight = pendingBooking.flight;

                      if (selectedOption === "recommended") {
                        finalFlight = recommendedFlight?.[0];
                      }

                      if (selectedOption === "original" && !remark) {
                        alert("Please select a remark");
                        return;
                      }

                      await proceedBooking(
                        finalFlight,
                        selectedOption === "recommended" ? 0 : pendingBooking.index,
                        recommendedFlight?.[0]
                      );

                      setShowPopup(false);
                    }}
                  >
                    Continue
                  </button>
                </div>

              </div>
            </div>
          )}

          <div className="col-md-3 col-lg-3 mobile-none">
            {/* Onward Flight Filter */}
            {!isRoundTrip && onwardDate && (
              <FilterSidebar
                flights={onwardFlights}
                filters={onwardFilters}
                onFilterChange={handleOnwardFilterChange}
              />
            )}

            {/* Return Flight Filter */}
            {isRoundTrip && isDomestic && (
              <>
                <FilterSidebar
                  flights={onwardFlights}
                  filters={onwardFilters}
                  onFilterChange={handleOnwardFilterChange}
                />
                <FilterSidebarDom
                  flights={returnFlights}
                  filters={returnFilters}
                  onFilterChange={handleReturnFilterChange}
                />
              </>
            )}

            {isRoundTrip && !isDomestic && (
              <FilterSidebar
                flights={returnFlights}
                filters={returnFilters}
                onFilterChange={handleReturnFilterChange}
              />
            )}
          </div>
          <div class="col-md-9 col-lg-9">
            <div class="box_shadow_wbg">

              {!isRoundTrip && onwardDate && (
                <ResultHtml
                  data={data}
                  totalPax={totalPax}
                  requestBody={requestBody}
                  flights={filteredOnward}
                  loading={loading}
                  error={error}
                  handleBookNow={handleBookNow}
                />
              )}

              {isRoundTrip && isDomestic && (
                <DomRoundTrip
                  onwardFlights={onwardFlights}
                  returnFlights={returnFlights}
                  filteredOnwardFlights={filteredOnward}
                  filteredReturnFlights={filteredReturn}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  loading={loading}
                  data={{
                    ...data,
                    departureAirportCode: originCode,
                    arrivalAirportCode: destCode
                  }}
                  error={error}
                  handleBookNow={handleBookNow}
                  requestBody={requestBody}
                />
              )}

              {isRoundTrip && !isDomestic && (
                <IntRoundTrip
                  totalPax={totalPax}
                  requestBody={requestBody}
                  onwardFlights={filteredOnward}
                  returnFlights={filteredReturn}
                  loading={loading}
                  data={{
                    ...data,
                    departureAirportCode: originCode,
                    arrivalAirportCode: destCode,
                  }}
                  handleBookNow={handleBookNow}
                />
              )}

              {/* <MultiCityresult /> */}
              {/* Domestic  */}
              {/* <MultiCityDomResult /> */}
              {/* International  */}
              {/* <MultiCityIntResult /> */}

            </div>
          </div>

        </div>
      </section>



      <div class="modal fade" id="MapView">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Map View</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">Modal body..</div>
          </div>
        </div>
      </div>


      {/* Modify Result Modal */}
      <div className="modal fade" id="ModifyResult">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Modify Result</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body-update">
              <ModifySearch />
            </div>
          </div>
        </div>
      </div>

    </>
  )
};

export default Result;